// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".size-sm[data-v-3311ac2f] {\n  font-size: 1rem;\n}\n@media (min-width: 576px) {\n.size-sm[data-v-3311ac2f] {\n    font-size: 1rem;\n}\n}\n@media (min-width: 768px) {\n.size-md[data-v-3311ac2f] {\n    font-size: 1rem;\n}\n}\n@media (min-width: 992px) {\n.size-lg[data-v-3311ac2f] {\n    font-size: 1.5rem;\n}\n}\n@media (min-width: 1200px) {\n.size-xl[data-v-3311ac2f] {\n    font-size: 1rem;\n}\n}\n", ""]);
// Exports
module.exports = exports;
